import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router';
import { LOGIN_STATE } from '@xingternal/xing-frame-provider';
import { useLoginState } from '@xingternal/hops';

import { getLoginUrl } from '@xingternal/pages-common';

const AuthenticatedRoute = ({ location, ...routeProps }: RouteProps) => {
  const loginState = useLoginState();
  if (loginState === LOGIN_STATE.loggedOut && location) {
    return <Redirect to={getLoginUrl({ location: location.pathname })} />;
  } else {
    return <Route {...routeProps} />;
  }
};

export default AuthenticatedRoute;
